export const ALERT_LOADER = 3000;
export const DEFAULT_LOADER = 1500;
export const SHORT_LOADER = 500;
export const USER_INFORMATION = 'USER_INFORMATION';
export const USER_REGISTRATION = 'USER_REGISTRATION';
export const ALLOWED_FORMATS = ['pdf', 'jpg', 'jpeg', 'png'];
